import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AudioService } from '../outer-services/audio.service';

@Component({
  selector: 'app-audio-button',
  template: `
    <span class='audioFocus ms-1' role='button' tabindex='0' [ngStyle]="audio_data && audio_data[0] && audio_data[1] && audio_data[0].src && audio_data[1].src?{'display':'inline-block'}:{'display':'none'}"
    (click)="$event.stopPropagation(); startAudio();"
    (keyup.enter)='$event.stopPropagation(); startAudio();'
    >
      <i class="fa fa-volume-up pointer" aria-label='audio' #audioIcon style="color:black;opacity:.5;font-size:1rem!important;"
      [ngClass]="isPlaying ? 'fa-beat' : ''"
      [ngStyle]="isPlaying ? {'color':'#004467'} : {'color':'black', 'opacity':'.5'}"
      ></i>
    </span>

    <audio hidden #audioTag>
      <source
        *ngIf="audio_data && audio_data[0] && audio_data[0].src"
        src="{{ audio_data[0].src }}"
        type="{{ audio_data[0].type }}"
      />
      <source
        *ngIf="audio_data && audio_data[1] && audio_data[1].src"
        src="{{ audio_data[1].src }}"
        type="{{ audio_data[1].type }}"
      />
    </audio>
  `,
  styles: [
    `
    .audioFocus:focus{
      outline: 1px solid #1C3867 !important;
      outline-offset: 2px !important;
    }
   `
  ],
  standalone: false
})
export class AudioButtonComponent implements OnInit {
  @ViewChild('audioIcon') audioIcon: ElementRef;
  @ViewChild('audioTag') audioTag: ElementRef;
  @Input() audio_data;

  /**current play status */
  isPlaying = false;
  private readonly handleDocumentPlay = (event: Event) => {
    if (this.audioTag?.nativeElement !== event.target) {
      this.stopAudio(true);
    }
  };

  constructor(private audioService: AudioService) { }

  ngOnInit() {
    this.audioService.closeEvent
      .subscribe(() => {
        if (this.audioIcon && this.audioTag) {
          this.stopAudio();
        }
      })
  }

  startAudio() {
    if (!this.isPlaying) {
      this.audioTag.nativeElement.load();
      this.audioTag.nativeElement.play();
      this.audioIcon.nativeElement.style.opacity = '1';
      this.isPlaying = true;
    } else {
      this.stopAudio();
    }
  }

  private stopAudio(resetCurrentTime = false) {
    this.audioTag.nativeElement.pause();
    if (resetCurrentTime) {
      this.audioTag.nativeElement.currentTime = 0;
    }
    this.audioIcon.nativeElement.style.opacity = '.5';
    this.isPlaying = false;
  }

  ngAfterViewInit() {
    this.audioTag.nativeElement.onended = () => {
      this.stopAudio(true);
    };
    document.addEventListener('play', this.handleDocumentPlay, true);
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    document.removeEventListener('play', this.handleDocumentPlay, true);
  }
}
